<template>
	<div>
			<div class="invoice">
			<h4 style="margin-bottom: 0px">{{ details.name }}, thank you for your order!</h4>
			<div style="display: flex; justify-content: space-between">
				<h4>Invoice {{ invoiceNumber }}</h4>
				<p></p>
				<h4>Amount Due HKD: ${{ details.amount_due.toFixed(2) }}</h4>
			</div>
			<hr style="margin-top: -5px" />
			
			<table v-if="showdetails" style="width: 100%">
				<tr>
					<th>Description</th>
					<th style="float: right">Amount</th>
				</tr>
				<tr v-for="(line, index) in details.lines" :key="index">
					<td style="width: 80%">
						{{ line.Name }}<br />
						<div v-if="line.Comment">
							<br /><em>{{ line.Comment }}</em>
						</div>
						<br />{{ line.Quantity.toFixed(2) }} x {{ line.Price }}
					</td>
					<td style="float: right">${{ line.Total.toFixed(2) }}</td>
				</tr>
				<tr v-for="(charge, index) in details.charges" :key="index+200">
					<td style="width: 80%">{{ charge.Description }}<br /><br />{{ charge.Quantity.toFixed(2) }} x {{ charge.Price }}</td>
					<td style="float: right">${{ charge.Total.toFixed(2) }}</td>
				</tr>
			</table>
			<span @click="showInvoiceDetails" style="cursor: pointer; margin-bottom: 5px; font-style: italic">{{!showdetails ? "Show" : "Hide"}} invoice details</span>
			
			
		</div>
		<div class="payment-method">
			<!--<div class="button" @click="showBrainTree">Credit Cards / Apple Pay</div>-->
			<transition>
				<Braintree v-if="braintree" :endpoint="endpoint" :amount="details.amount_due.toFixed(2)" :invoiceNumber="invoiceNumber" @nonceLoaded="nonceLoaded" />
			</transition>
			<h5>Or, pay with:</h5>
			<div style="width:70%;margin:auto;display:flex;flex-direction:column;justify-content:center;align-items:center">
			<div class="button" @click="$emit('methodChosen', 'QFPay')" style="width:100%;margin:auto">AlipayHK / Alipay / Wechat Pay / FPS</div>
			<div id="paypal-button-container" class="paypal-button"></div>
			</div>
		</div>


	</div>
</template>

<script>
	import { loadScript } from "@paypal/paypal-js";
	import Braintree from "./Braintree.vue";
	export default {
		name: "InvoiceDetails",
		props: ["details", "endpoint", "name", "invoiceNumber"],
		components: { Braintree },
		data() {
			return {
				braintree: true,
				showdetails: false,
			};
		},
		mounted() {
			let urlParams = new URLSearchParams(window.location.search);
			if(urlParams.get('pp34') == "true")
				this.mountpaypalbutton();
		},
		methods: {
			mountpaypalbutton() {
				let id = this.details.id;
				let invoice_amount = this.details.invoice_total;
				loadScript({ "client-id": this.ppclientid, currency: "HKD" }) // production
					.then((paypal) => {
						const paypalButtonsComponent = paypal.Buttons({
							fundingSource: paypal.FUNDING.PAYPAL,
							style: {
								color: "white",
								shape: "pill",
								layout: "horizontal",
								height: 38,
							},

							// set up the transaction
							createOrder: (data, actions) => {
								// pass in any options from the v2 orders create call:
								// https://developer.paypal.com/api/orders/v2/#orders-create-request-body
								const createOrderPayload = {
									purchase_units: [
										{
											reference_id: this.details.id,
											amount: {
												value: this.details.amount_due,
											},
										},
									],
								};

								return actions.order.create(createOrderPayload);
							},

							// finalize the transaction
							onApprove: (data, actions) => {
								const captureOrderHandler = (details) => {
									this.$emit("paymentDone", "Paypal", details.id);
									const payerName = details.payer.name.given_name;
								};

								return actions.order.capture().then(captureOrderHandler);
							},

							// handle unrecoverable errors
							onError: (err) => {
								alert("An error has occured with PayPal. Please try again.");
								console.error("An error prevented the buyer from checking out with PayPal");
							},
						});

						paypalButtonsComponent.render("#paypal-button-container").catch((err) => {
							console.error("PayPal Buttons failed to render");
						});
					})
					.catch((err) => {
						console.error("failed to load the PayPal JS SDK script", err);
					});
			},
			showBrainTree() {
				this.braintree = true;
			},
			nonceLoaded(payload, save, allow) {
				this.$emit("nonceLoaded", payload, save, allow);
			},
			showInvoiceDetails() {
				this.showdetails = !this.showdetails;
			},

		},
		computed: {
			ppclientid() {
				if(window.location.href.includes('localhost')) {
					return"AfwhSt6svwhlwboNA-bOkSF5_BXgJpRZKiFvQpe5Q92RGsts9ri1ECnDouTdmn1PQC8BnJOY2ml2e-bc"
				} else {
					return 'AYYi1JgQ3Mw5u3hzlKvWmqmcUM-81ayiquSesmcJrYUEoPEo2RCys45auyBpgt35WqeHIHToKDaNWmNl'
				}
			},			
		}
	};
</script>

<style scoped>
	.paypal-button {
		width:100%;
		margin-top:2em;
	}
	.button {
		background-color: #431266;
		color: white;
		padding-top:10px;
		padding-bottom:10px;
		text-align: center;
		
		border-radius: 20px;
		cursor: pointer;
	}
	.invoice {
		background: #eee;
		border-radius: 20px;
		padding: 5px;
		padding-left: 20px;
		padding-right: 20px;
		margin-left: 10px;
		margin-right: 10px;
		text-align: left;
		margin-top:2em;
	}

	.payment-method {
		background: #eee;
		border-radius: 20px;
		padding: 5px;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
		margin-top: 20px;
		margin-left: 10px;
		margin-right: 10px;
		text-align: left;
	}
	table td {
		padding-bottom: 1em;
	}
</style>


// WEBPACK FOOTER //
// src/components/InvoiceDetails.vue